import { render } from "./SizeControl.vue?vue&type=template&id=599876f7"
import script from "./SizeControl.vue?vue&type=script&lang=js"
export * from "./SizeControl.vue?vue&type=script&lang=js"
script.render = render

export default script